import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import ReviewSubmitGuidelines from 'components/review-submit/ReviewSubmitGuidelines';
import ReviewSubmitResults from 'components/review-submit/ReviewSubmitResults';
import ReviewSubmitHeader from 'components/review-submit/ReviewSubmitHeader';
import ReviewSubmitFooter from 'components/review-submit/ReviewSubmitFooter';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { useParams } from 'react-router-dom';
import ActionModal from 'components/common/modals/ActionModal';
import { toJS } from 'mobx';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { createStyles } from './styles';

const ReviewSubmitContent: React.FC = observer(() => {
  const { periodId } = useParams<{ periodId: string }>();
  const query = useQueryParams();
  const groupId = query.get('groupId') || '';
  const {
    reviewSubmitStore: {
      loading,
      getUwResults,
      isNewSaleEnrollmentPeriod,
      isWarningModalOpen,
      electionsCheck,
      setIsWarningModalOpen,
    },
    domainStoreV2,
  } = useRootStore();

  const subsWithoutElection = toJS(electionsCheck).subsWithoutElection;

  useEffect(() => {
    void getUwResults(groupId, periodId);
  }, []);

  const classes = createStyles();
  return (
    <>
      {!domainStoreV2.loading && !loading && (
        <>
          <ReviewSubmitHeader />
          <div className={classes.contentWrapper}>
            {isNewSaleEnrollmentPeriod && <ReviewSubmitGuidelines />}
            <ReviewSubmitResults />
          </div>
          <ReviewSubmitFooter />
        </>
      )}
      <ActionModal
        show={isWarningModalOpen}
        onClose={(): void => setIsWarningModalOpen(false)}
        title="Warning"
        subtitle={`Warning! You had ${subsWithoutElection} ${
          subsWithoutElection === 1 ? 'employee' : 'employees'
        } with NO elections, all of them were waived. You can still go back to employee elections and change election status.`}
        closeButtonText="Close"
      />
      <FormsSpinner display={domainStoreV2.loading || loading} />
    </>
  );
});

export default ReviewSubmitContent;
